import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { normaliseResults } from 'libs/searchspring/helpers/normalisers'

import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringSearch extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query, originalQuery, page, resultsPerPage, tag, filters, sort } = options
    if (!query || query === 'null') return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (tag) this.params.set('tag', tag)

    if (sort) this.params.setSort(sort); else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const SearchspringSearchProvider = generateSearchspringProvider(SearchspringSearch, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return {
    ...results,
    results: normalisedResults
  }
})
